export interface CommitteeMatrix {
  id: string;
  name: string;
  category: string;
  categoryGroup: 'UN' | 'Indian' | 'Crisis' | 'Auction' | 'Press';
  totalCount: number;
  track: 'Conventional' | 'Auction';
  formUrl: string;
  portfolios: string[];
}

export const COMMITTEE_MATRICES: CommitteeMatrix[] = [
  {
    id: 'unga',
    name: 'UNGA (United Nations General Assembly)',
    category: 'International',
    categoryGroup: 'UN',
    totalCount: 30,
    track: 'Conventional',
    formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLScp6DL6ZttmyOwF5Zffu_qk3cBaCDaYzo9TTteNmo_WQfkoxA/viewform',
    portfolios: [
      'India',
      'United States of America',
      'United Kingdom',
      'France',
      'Russian Federation',
      'People’s Republic of China',
      'Japan',
      'Germany',
      'Brazil',
      'Canada',
      'Australia',
      'Republic of Korea',
      'Democratic People’s Republic of Korea',
      'Pakistan',
      'United Arab Emirates',
      'The Kingdom of Saudi Arabia',
      'The State of Israel',
      'Islamic Republic of Iran',
      'Ukraine',
      'The Republic of South Africa',
      'Egypt',
      'Nigeria',
      'Mexico',
      'Indonesia',
      'Turkiye',
      'Italy',
      'Spain',
      'Argentina',
      'Switzerland',
      'Netherlands',
    ],
  },
  {
    id: 'ecosoc',
    name: 'ECOSOC (UN Economic and Social Council)',
    category: 'International',
    categoryGroup: 'UN',
    totalCount: 30,
    track: 'Conventional',
    formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLScp6DL6ZttmyOwF5Zffu_qk3cBaCDaYzo9TTteNmo_WQfkoxA/viewform',
    portfolios: [
      'India',
      'United States of America',
      'Russian Federation',
      'People’s Republic of China',
      'Islamic Republic of Iran',
      'Japan',
      'Germany',
      'United Kingdom',
      'France',
      'Brazil',
      'Canada',
      'Australia',
      'Republic of Korea',
      'Indonesia',
      'Mexico',
      'South Africa',
      'Nigeria',
      'Egypt',
      'United Arab Emirates',
      'Kingdom of Saudi Arabia',
      'Türkiye',
      'Italy',
      'Spain',
      'Sri Lanka',
      'Switzerland',
      'Netherlands',
      'Norway',
      'Sweden',
      'Singapore',
      'Malaysia',
    ],
  },
  {
    id: 'lok-sabha',
    name: 'LOK SABHA (House of the People)',
    category: 'Indian Parliamentary',
    categoryGroup: 'Indian',
    totalCount: 35,
    track: 'Conventional',
    formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLScp6DL6ZttmyOwF5Zffu_qk3cBaCDaYzo9TTteNmo_WQfkoxA/viewform',
    portfolios: [
      'Narendra Modi',
      'Amit Shah',
      'Rahul Gandhi',
      'Gaurav Gogoi',
      'Rajnath Singh',
      'Nirmala Sitharaman',
      'S. Jaishankar',
      'Nitin Gadkari',
      'Shivraj Singh Chouhan',
      'Piyush Goyal',
      'Dharmendra Pradhan',
      'Ashwini Vaishnaw',
      'Kiren Rijiju',
      'Jyotiraditya Scindia',
      'K. R. Mohan Naidu',
      'Chirag Paswan',
      'Rajiv Ranjan (Lalan) Singh',
      'Mansukh Mandaviya',
      'Dr. Jitendra Singh',
      'Arjun Ram Meghwal',
      'Akhilesh Yadav',
      'Dr. Shashi Tharoor',
      'Manish Tewari',
      'K. C. Venugopal',
      'Abhishek Banerjee',
      'Mahua Moitra',
      'T. R. Baalu',
      'K. Karunanidhi',
      'Dimple Yadav',
      'Supriya Sule',
      'Arvind Sawant',
      'Asaduddin Owaisi',
      'Harsimrat Kaur Badal',
      'Chandrashekhar Azad',
      'Sheikh Abdul Rashid',
    ],
  },
  {
    id: 'aippm',
    name: 'AIPPM (All India Political Parties Meet)',
    category: 'Indian Parliamentary',
    categoryGroup: 'Indian',
    totalCount: 30,
    track: 'Conventional',
    formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLScp6DL6ZttmyOwF5Zffu_qk3cBaCDaYzo9TTteNmo_WQfkoxA/viewform',
    portfolios: [
      'Narendra Modi',
      'Amit Shah',
      'Rahul Gandhi',
      'Mallikarjun Kharge',
      'Gaurav Gogoi',
      'Arvind Kejriwal',
      'Mamata Banerjee',
      'Akhilesh Yadav',
      'Yogi Adityanath',
      'M.K. Stalin',
      'N. Chandrababu Naidu',
      'Nitish Kumar',
      'Hemant Soren',
      'Himanta Biswa Sarma',
      'Pinarayi Vijayan',
      'Bhagwant Mann',
      'Devendra Fadnavis',
      'Uddhav Thackeray',
      'Sharad Pawar',
      'Supriya Sule',
      'Asaduddin Owaisi',
      'Priyanka Gandhi Vadra',
      'Shashi Tharoor',
      'K. Annamalai',
      'Tejashwi Yadav',
      'Omar Abdullah',
      'Mehbooba Mufti',
      'Jairam Ramesh',
      'Derek O’Brien',
      'D. Raja',
    ],
  },
  {
    id: 'dead-poets-society',
    name: 'DEAD POETS SOCIETY (CCC)',
    category: 'Crisis & Specialized',
    categoryGroup: 'Crisis',
    totalCount: 25,
    track: 'Conventional',
    formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLScp6DL6ZttmyOwF5Zffu_qk3cBaCDaYzo9TTteNmo_WQfkoxA/viewform',
    portfolios: [
      'John Keating',
      'Neil Perry',
      'Todd Anderson',
      'Charlie Dalton',
      'Knox Overstreet',
      'Richard Cameron',
      'Gerard Pitts',
      'Steven Meeks',
      'Mr. Thomas Perry',
      'Mrs. Perry',
      'Mr. Anderson',
      'Mrs. Anderson',
      'Gale Nolan',
      'Mr. George McAllister',
      'Dr. Hager',
      'English Dept. Representative',
      'Arts and Theatre Representative',
      'Parents’ Association Representative',
      'School Board Trustee 1',
      'School Board Trustee 2',
      'School Chaplain',
      'School Counsellor',
      'Independent Student Journalist',
      'Independent Media House Journalist',
      'Education Inspector',
    ],
  },
  {
    id: 'rajputana-yuddh-parishad',
    name: 'RAJPUTANA YUDDH PARISHAD (CCC)',
    category: 'Crisis & Specialized',
    categoryGroup: 'Crisis',
    totalCount: 30,
    track: 'Conventional',
    formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLScp6DL6ZttmyOwF5Zffu_qk3cBaCDaYzo9TTteNmo_WQfkoxA/viewform',
    portfolios: [
      'Maharana Pratap Singh I',
      'Kunwar Amar Singh I',
      'Bhamashah',
      'Hakeem Khan Sur',
      'Rao Chandrasen Rathore',
      'Ram Das Panwar',
      'Mann Singh Jhala',
      'Rawat Krishnadas Chundawat',
      'Rawat Sangram Singh Sangawat',
      'Thakur Keshav Das',
      'Rao Kalla Of Marwar',
      'Rao Surjan Hada',
      'Acharya Raghavendra',
      'Rana Punja Bhil',
      'Barahad Keshav Das',
      'Mirza Aziz Koka',
      'Shahbaz Khan Kamboh',
      'Raja Todar Mal',
      'Raja Man Singh I of Amber',
      'Qasim Khan Mir Bahr',
      'Saiyid Ahmad Khan Barha',
      'Prince Salim',
      'Raja Bhagwant Das',
      'Jalal Khan Qurchi',
      'Rai Singh of Bikaner',
      'Imperial Gujarati',
      'Abul Faiz',
      'Imperial Supply Command Officer',
      'Peyanda Khan',
      'Abul Fazl ibn Mubarak',
    ],
  },
  {
    id: 'ipl',
    name: 'IPL (AUCTION)',
    category: 'Auction',
    categoryGroup: 'Auction',
    totalCount: 15,
    track: 'Auction',
    formUrl: 'https://docs.google.com/forms/d/1aZ_JDtwvM5adaHJK-5STyKYu8jj1Vzd7pdFBzj609BE/viewform',
    portfolios: [
      'Royal Challengers Bengaluru',
      'Mumbai Indians',
      'Chennai Super Kings',
      'Gujarat Titans',
      'Delhi Capitals',
      'Punjab Kings',
      'Lucknow Super Giants',
      'Rajasthan Royals',
      'Sunrisers Hyderabad',
      'Deccan Chargers',
      'Kolkata Knight Riders',
      'Gujarat Lions',
      'Kerala Blasters',
      'Kochi Tuskers',
      'Rising Pune Super Giants',
    ],
  },
  {
    id: 'fifa',
    name: 'FIFA (AUCTION) — Mega Auction',
    category: 'Auction',
    categoryGroup: 'Auction',
    totalCount: 15,
    track: 'Auction',
    formUrl: 'https://docs.google.com/forms/d/1aZ_JDtwvM5adaHJK-5STyKYu8jj1Vzd7pdFBzj609BE/viewform',
    portfolios: [
      'FC Barcelona',
      'Real Madrid',
      'Manchester City',
      'Manchester United',
      'Liverpool FC',
      'Arsenal FC',
      'Paris Saint-Germain',
      'Inter Milan',
      'Chelsea F.C.',
      'Juventus FC',
      'FC Bayern Munich',
      'Borussia Dortmund',
      'Atlético Madrid',
      'AC Milan',
      'AFC Ajax',
    ],
  },
  {
    id: 'ip',
    name: 'INTERNATIONAL PRESS (IP)',
    category: 'Crisis & Specialized',
    categoryGroup: 'Press',
    totalCount: 2,
    track: 'Conventional',
    formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLScp6DL6ZttmyOwF5Zffu_qk3cBaCDaYzo9TTteNmo_WQfkoxA/viewform',
    portfolios: [
      'Journalist',
      'Photo Journalist',
    ],
  },
];

export const MATRICES_PDF_URL = '/documents/FLSxMUN_2.0_Matrices.pdf';
